<template>
  <article class="price-list">
    <slot v-if="$slots.default" />

    <LcSeparator class="my-md" />

    <LcDescriptionList class="gap-2xs">
      <dt class="subtotal">
        {{ $t('pricelist.labels.subtotal') }}
      </dt>
      <dd class="subtotal text-right">{{ chargeTotal }}</dd>

      <template v-if="showConvenienceFee">
        <dt class="flex gap-xs items-center">
          {{ $t('pricelist.labels.conveniencefee') }}

          <LcInfoButton
            :headline="$t('infobutton.conveniencefee.headline')"
            :open-button-aria-label="$t('infobutton.conveniencefee.label')"
            tabindex="-1"
            :text="$t('infobutton.conveniencefee.message')"
          />
        </dt>
        <dd class="text-right">{{ convenienceFee }}</dd>
      </template>

      <template v-if="showSalesTax">
        <dt>{{ $t('pricelist.labels.salestax') }}</dt>
        <dd class="text-right">{{ salesTax }}</dd>
      </template>
    </LcDescriptionList>
  </article>
</template>

<script lang="ts" setup>
import type Money from '~/models/Money'

type PriceListProps = {
  chargeTotal: Money
  convenienceFee: Money
  salesTax: Money
  showSalesTax?: boolean
}

const props = withDefaults(defineProps<PriceListProps>(), {
  showSalesTax: false,
})

const { convenienceFee } = toRefs(props)
const showConvenienceFee = computed(() => convenienceFee.value.value > 0)
</script>

<style lang="scss" scoped>
.price-list {
  padding-right: 1.5rem;

  .subtotal {
    font-weight: $font-weight-medium;
    font-size: $font-size-h5;
  }
}
</style>
